module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/french-bread-eec563b110576a2ef046da49de116c1f.svg";